/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PopupBaseComponent } from '../popup-base.component';

@Component({
	selector: 'simple-popup',
	templateUrl: './simple-popup.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimplePopupComponent extends PopupBaseComponent {}
